import { createSelector } from 'reselect';
import { IAppStoreState } from 'app_redux/types';

const localeSelector = (state: IAppStoreState) => {
    return state.locale;
};

export const getAppLocale = createSelector(localeSelector, (locale: string) => locale);
